import {
  ApiIcon,
  BrickWallIcon,
  Calendar03Icon,
  ChartColumnStackedIcon,
  CheckListIcon,
  Coins01Icon,
  ComputerTerminalIcon,
  CustomizeIcon,
  DashboardSquare01Icon,
  DrawingModeIcon,
  Flag01Icon,
  GridIcon,
  InboxIcon,
  LiveStreaming01Icon,
  MapPinIcon,
  Package01Icon,
  Robot01Icon,
  Settings05Icon,
  Shield01Icon,
  StructureCheckIcon,
  TaskDaily01Icon,
  UserGroupIcon,
  Video01Icon,
} from '@hugeicons/core-free-icons';
import { MdHistoryEdu, MdOutlineFactory, MdWaterfallChart } from 'react-icons/md';
import { TbBook } from 'react-icons/tb';

import { createHugeIcon } from './create-huge-icon';
import { createReactIcon } from './create-react-icon';

export const DashboardsIcon = createReactIcon(MdWaterfallChart, 'DashboardsIcon');
export const PlanningIcon = createHugeIcon(Calendar03Icon, 'PlanningIcon');
export const FactoryIcon = createReactIcon(MdOutlineFactory, 'FactoryIcon');
export const QualityIcon = createHugeIcon(CheckListIcon, 'QualityIcon');
export const CatalogueIcon = createReactIcon(TbBook, 'CatalogueIcon');
export const SettingsIcon = createHugeIcon(Settings05Icon, 'SettingsIcon');
export const LegacyIcon = createReactIcon(MdHistoryEdu, 'LegacyIcon');
export const StatusboardIcon = createHugeIcon(DashboardSquare01Icon, 'StatusboardIcon');
export const FlowIcon = createHugeIcon(StructureCheckIcon, 'FlowIcon');
export const JobCardIcon = createHugeIcon(TaskDaily01Icon, 'JobCardIcon');
export const LiveFeedIcon = createHugeIcon(LiveStreaming01Icon, 'LiveFeedIcon');
export const QualityInboxIcon = createHugeIcon(InboxIcon, 'QualityInboxIcon');
export const QualityPackIcon = createHugeIcon(CheckListIcon, 'QualityPackIcon');
export const ProjectIcon = createHugeIcon(Calendar03Icon, 'ProjectIcon');
export const ProductionPlanIcon = createHugeIcon(GridIcon, 'ProductionPlanIcon');
export const DrawingControlIcon = createHugeIcon(DrawingModeIcon, 'DrawingControlIcon');
export const ZoneIcon = createHugeIcon(MapPinIcon, 'ZoneIcon');
export const StationIcon = createHugeIcon(Robot01Icon, 'StationIcon');
export const DfMAContainerIcon = createHugeIcon(Package01Icon, 'DfMAContainerIcon');
export const StandardColumnIcon = createHugeIcon(ChartColumnStackedIcon, 'StandardColumnIcon');
export const CustomColumnIcon = createHugeIcon(CustomizeIcon, 'CustomColumnIcon');
export const WorkforceIcon = createHugeIcon(UserGroupIcon, 'WorkforceIcon');
export const ShiftPatternIcon = createHugeIcon(Calendar03Icon, 'ShiftPatternIcon');
export const DevicesIcon = createHugeIcon(ComputerTerminalIcon, 'DevicesIcon');
export const AdminIcon = createHugeIcon(Shield01Icon, 'AdminIcon');
export const ContainerLibraryIcon = createHugeIcon(Package01Icon, 'ContainerLibraryIcon');
export const FeatureFlagIcon = createHugeIcon(Flag01Icon, 'FeatureFlagIcon');
export const VideoIcon = createHugeIcon(Video01Icon, 'VideoIcon');
export const OperatingCostsIcon = createHugeIcon(Coins01Icon, 'OperatingCostsIcon');
export const MaterialsIcon = createHugeIcon(BrickWallIcon, 'MaterialsIcon');
export const PartnerApiIcon = createHugeIcon(ApiIcon, 'PartnerApiIcon');
